import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=248220f1&scoped=true"
import script from "./DeliveryForm.vue?vue&type=script&lang=js"
export * from "./DeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./DeliveryForm.vue?vue&type=style&index=0&id=248220f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248220f1",
  null
  
)

export default component.exports